import { API_FETCH_TIMEOUT, apiUrl } from '@ahm/api-wrappers-core';
import axios from 'axios';

export const webviewHttpClient = axios.create({
  baseURL: apiUrl,
  timeout: API_FETCH_TIMEOUT * 1000,
  headers: {
    'Content-Type': 'application/json',
  },
});
